'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _MozartTextBox = require('../../MozartTextBox');

var _MozartTextBox2 = _interopRequireDefault(_MozartTextBox);

var _MozartPagination = require('../../MozartPagination');

var _MozartPagination2 = _interopRequireDefault(_MozartPagination);

var _reactVirtualized = require('react-virtualized');

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MozartGrid = function (_Component) {
  _inherits(MozartGrid, _Component);

  function MozartGrid(props) {
    _classCallCheck(this, MozartGrid);

    var _this = _possibleConstructorReturn(this, (MozartGrid.__proto__ || Object.getPrototypeOf(MozartGrid)).call(this, props));

    var data = _this.getData(_this.props.data);
    _this.state = {
      list: data,
      currTotalPage: Math.ceil(data.length / 10),
      currPage: 0,
      data: ''
    };
    return _this;
  }

  _createClass(MozartGrid, [{
    key: 'handleSearch',
    value: function handleSearch() {
      var _this2 = this;

      var handleSearch = this.props.handleSearch;

      var newdata = handleSearch ? handleSearch(this.state.data) : this.state.list;
      var newRowdata = this.getData(newdata);
      this.setState({
        list: newRowdata,
        currTotalPage: Math.ceil(newRowdata.length / 10),
        currPage: 0
      }, function () {
        if (_this2.refs.list) {
          _this2.refs.list.forceUpdateGrid();
        }
      });
    }
  }, {
    key: 'getData',
    value: function getData(data) {
      var _props = this.props,
          dataStyle = _props.dataStyle,
          colNum = _props.colNum;

      var style = colNum > 1 ? Object.assign(dataStyle, { display: 'flex' }) : dataStyle;
      var res = [];
      if (data) {
        if (colNum === 1) {
          return data.map(function (item) {
            return _react2.default.createElement(
              'div',
              { style: style },
              item
            );
          });
        } else {
          var ind = 0;
          while (ind < data.length) {
            res.push(_react2.default.createElement(
              'div',
              { style: style },
              data[ind],
              ind + 1 < data.length ? data[ind + 1] : ''
            ));
            ind += 2;
          }
          return res;
        }
      } else {
        return [];
      }
    }
  }, {
    key: 'displayDataBasedOnPage',
    value: function displayDataBasedOnPage(start, end) {
      var res = [];
      for (var ind = start; ind <= end; ind++) {
        res.push(this.state.list[ind]);
      }
      return res;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props2 = this.props,
          data = _props2.data,
          style = _props2.style,
          virWidth = _props2.virWidth,
          virHeight = _props2.virHeight,
          loadType = _props2.loadType,
          handleSearch = _props2.handleSearch,
          searchBoxWidth = _props2.searchBoxWidth,
          themeId = _props2.themeId;
      var _state = this.state,
          list = _state.list,
          currTotalPage = _state.currTotalPage,
          currPage = _state.currPage;

      return _react2.default.createElement(
        'div',
        { style: style, 'data-qa': this.props.testId, 'data-theme': themeId },
        data && handleSearch && _react2.default.createElement(_MozartTextBox2.default, {
          style: { width: searchBoxWidth ? searchBoxWidth : virWidth },
          ref: 'grid_textarea',
          key: 'grid_textarea',
          id: 'grid_textarea',
          className: 'grid_textarea',
          validationBool: false,
          name: 'grid_textarea',
          borderInputBox: true,
          hintText: 'Search',
          multiLine: false,
          onChange: (0, _utils.debounce)(function (data) {
            _this3.setState({ data: data }, _this3.handleSearch.bind(_this3));
          }, 500),
          icon: _react2.default.createElement('span', { className: 'icon-Search', onClick: function onClick() {
              _this3.handleSearch();
            } }) }),
        data && loadType === 'scroll' && _react2.default.createElement(
          _reactVirtualized.WindowScroller,
          null,
          function (_ref) {
            var height = _ref.height,
                isScrolling = _ref.isScrolling,
                onChildScroll = _ref.onChildScroll,
                scrollTop = _ref.scrollTop;
            return _react2.default.createElement(_reactVirtualized.List, {
              ref: 'list',
              autoHeight: true,
              height: height,
              isScrolling: isScrolling,
              onScroll: onChildScroll,
              rowCount: list.length,
              rowHeight: virHeight,
              rowRenderer: function rowRenderer(_ref2) {
                var key = _ref2.key,
                    index = _ref2.index,
                    style = _ref2.style;

                return _react2.default.createElement(
                  'div',
                  { key: key, style: style },
                  list[index]
                );
              },
              scrollTop: scrollTop,
              width: virWidth
            });
          }
        ),
        data && list.length > 0 && loadType === 'pagination' && _react2.default.createElement(
          'div',
          { style: { width: virWidth } },
          this.displayDataBasedOnPage(currPage * 10, (currPage + 1) * 10 - 1),
          _react2.default.createElement(_MozartPagination2.default, {
            key: currTotalPage,
            pageCount: currTotalPage,
            onPageChange: function onPageChange(ind) {
              _this3.setState({ currPage: ind - 1 });
            },
            pageRangeDisplayed: 3,
            activeClassName: 'test'
          })
        )
      );
    }
  }]);

  return MozartGrid;
}(_react.Component);

MozartGrid.propTypes = {
  /** qa attribute */
  testId: _propTypes2.default.string,
  /** theme attribute */
  themeId: _propTypes2.default.string,
  /** style override */
  style: _propTypes2.default.object,
  /** rowStyle */
  dataStyle: _propTypes2.default.object,
  /** rows array */
  data: _propTypes2.default.array,
  /** item width for react-virtualized */
  virWidth: _propTypes2.default.number,
  /** item height for react-virtualized */
  virHeight: _propTypes2.default.number,
  /** search box width */
  searchBoxWidth: _propTypes2.default.string,
  /** load type of grid: pagination or scroll(virtualized) */
  loadType: _propTypes2.default.string,
  /** search callback function*/
  handleSearch: _propTypes2.default.func,
  /** specify nunber of columns*/
  colNum: _propTypes2.default.number
};
MozartGrid.defaultProps = {
  testId: 'MozartGrid',
  themeId: 'MozartGrid',
  style: {},
  loadType: 'scroll',
  colNum: 1
};
exports.default = MozartGrid;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Mozart/MozartTable/MozartGrid/MozartGrid.js
// module id = 2116
// module chunks = 1